// AppSync Configuration
// Use environment variables for flexibility across DEV and PROD
export const APPSYNC_URL =
  process.env.REACT_APP_TIS_GQL_URL ||
  'https://56exjy53zfey5bwvnr3q5qrh2a.appsync-api.us-east-1.amazonaws.com/graphql';
export const APPSYNC_REGION = process.env.REACT_APP_TIS_GQL_REGION || 'us-east-1';
